// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"solution_pageContainer__PrDlK","solutionContainer":"solution_solutionContainer__yBo_H","solution":"solution_solution__MvEK8","content":"solution_content__ggo3w"};